(() => {
  const main = document.getElementById('MainContent');
  if (!main) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const headingSelector = [
    'h1:not(.visually-hidden)',
    'h2:not(.visually-hidden)',
    '.section-header__title:not(.visually-hidden)',
    '.product-single__title:not(.visually-hidden)'
  ].join(',');
  const productSelector = '.grid-product:not(.slick-cloned)';
  const initialized = new WeakSet();

  const reveal = (element) => {
    element.classList.add('xpertza-motion-visible');
    if (motionObserver) motionObserver.unobserve(element);
  };

  const motionObserver = !reduceMotion && 'IntersectionObserver' in window
    ? new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) reveal(entry.target);
        });
      }, {
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
      })
    : null;

  const prepare = (element, type, delay = 0) => {
    if (initialized.has(element)) return;
    initialized.add(element);

    if (
      element.closest('.modal, .drawer, .quick-product, [hidden]') ||
      element.matches('.hero__title') ||
      (type === 'heading' && element.closest('.grid-product'))
    ) return;

    element.classList.add('xpertza-motion-item', `xpertza-motion-${type}`);
    element.style.setProperty('--xpertza-motion-delay', `${delay}ms`);

    if (reduceMotion || !motionObserver) {
      reveal(element);
      return;
    }

    const rect = element.getBoundingClientRect();
    if (rect.bottom < 0) {
      reveal(element);
    } else {
      motionObserver.observe(element);
    }
  };

  const initializeWithin = (scope) => {
    if (!(scope instanceof Element) && scope !== document) return;

    const headings = [];
    if (scope instanceof Element && scope.matches(headingSelector)) headings.push(scope);
    headings.push(...scope.querySelectorAll(headingSelector));
    [...new Set(headings)].forEach((heading) => prepare(heading, 'heading'));

    const products = [];
    if (scope instanceof Element && scope.matches(productSelector)) products.push(scope);
    products.push(...scope.querySelectorAll(productSelector));
    [...new Set(products)].forEach((product, index) => {
      prepare(product, 'product', Math.min(index % 4, 3) * 70);
    });
  };

  initializeWithin(main);

  const mutationObserver = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node instanceof Element) initializeWithin(node);
      });
    });
  });

  mutationObserver.observe(main, { childList: true, subtree: true });
  document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
})();
